import { Component } from "@angular/core";
@Component({
	selector: "sdi-contact-us",
	templateUrl: "./contact-us.component.html",
	styleUrls: ["./contact-us.component.scss"]
})
export class ContactUsComponent {}
